import { Bundle } from '@ali/visualengine';
import React from 'react';
// import { createSlot } from '@ali/vu-slot-property';
import Icon from './logo.tsx';
import { createMessageSetters } from '@/common/util/message';
import DocLinkSetter from '@/common/setter/doc-link-setter';
import { DisplayPosition } from '@/common/manager/position/display-position';

const CnMessageBundle = Bundle.createPrototype({
  title: '信息提示（CnMessage）',
  componentName: 'CnMessage',
  category: '反馈',
  icon: Icon,
  docUrl:
    'https://cone.cainiao-inc.com/market/awesome?business=internationality&id=3313',
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/tfs/TB1gaZrr.T1gK0jSZFhXXaAtVXa-1048-366.png',
      label: 'CnMessage',
      schema: {
        componentName: 'CnMessage',
        props: {},
      },
    },
  ],
  configure: [
    {
      name: 'doc',
      title: '使用文档',
      display: 'inline',
      setter: (
        <DocLinkSetter
          link={
            'https://alidocs.dingtalk.com/i/nodes/NkPaj7GAXdpWOkPeZ6p0Wqwgylnomz9B?iframeQuery=anchorId%3Dlc5uzai79stjyz5pyw'
          }
          content={'点击查看信息提示的正确使用姿势'}
        />
      ),
    },
    {
      title: '信息配置',
      type: 'group',
      collapsed: false,
      display: 'accordion',
      items: createMessageSetters({
        needMargin: true,
        position: DisplayPosition.message,
      }),
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
  ],
});

export default CnMessageBundle;
